import { useEffect, useState } from "react";

function FormikValidation ({formikValues, formikErrors, formikTouched, tech}) {
	const [errors, setErrors] = useState({});

	useEffect(() => {
		let filteredErrors = {};
		Object.keys(formikValues).forEach((key) => {
			if(formikErrors[key] && formikTouched[key]) {
				filteredErrors[key] = formikErrors[key];
			}
		})
		setErrors(filteredErrors);
	}, [formikValues, formikErrors, formikTouched])
	

	return (
		<>
			{Object.keys(errors).length > 0 && (
				tech ? (
					<p style={{'fontSize': '0.6em', 'color': 'gray'}}>Dati tecnici: {JSON.stringify(errors)}</p>
				) : (
					<p style={{'color': 'red', 'marginBottom': '0px', 'marginTop': '1em'}}>Ricontrolla gli errori indicati nei vari campi</p>
				)
			)
			}			
		</>
	);
}

export default FormikValidation;
